export function hasErrorStatuses(err, statuses, verifyByRange) {
    const statusCode = err?.statusCode;
    if (verifyByRange) {
        return statusCode >= statuses[0] && statusCode <= statuses.slice(-1);
    }
    return statuses.some((status) => String(status).includes(String(statusCode)));
}
;
//# sourceMappingURL=hasErrorStatuses.js.map